import React, { useEffect } from 'react';
import { Button } from '../_atoms';

import flag from '../styles/images/plug/flag.png';
import '../styles/redirect.scss';

const PATH_TO_APP_ANDROID = 'fotopostapp://lockforpayment';
const PATH_TO_APP_IOS = 'fotopostapp://';
export const RedirectPage = () => {
  const redirectToApp = () => {
    window.location.href = PATH_TO_APP_IOS;
    window.location.href = PATH_TO_APP_ANDROID;
  };

  useEffect(() => {
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = PATH_TO_APP_IOS;
    link.click();
    link.href = PATH_TO_APP_ANDROID;
    link.click();
    document.body.removeChild(link);
  }, []);
  return (
    <div className="page-redirect">
      <div className="page-redirect__content">
        <div className="flag">
          <img className="flag__main" src={flag} alt="" />
        </div>
        <div className="redirect">
          <Button onClick={redirectToApp}>Продолжить в ФотоПочте</Button>
        </div>
      </div>
    </div>
  );
};
